import Loader from "../Loader"
import { useEffect } from 'react'
import { useAuth0 } from '@auth0/auth0-react';
import { LoginAction } from "../../../Redux/Actions/AuthAction";
import { useDispatch } from "react-redux";

var CryptoJS = require("crypto-js");

const Redirect = () => {
    const dispatch = useDispatch()
    const CRYPTO_SECRATE_KEY = 'controlium-discover-tech'
    const {
        isAuthenticated,
        user,
        // getAccessTokenSilently,
    } = useAuth0();

    // useEffect(() => {
    //     getToken()
    //     // (async () => {
    //     //     console.log('user, jwt, token', isAuthenticated);
    //     //     if (isAuthenticated) {
    //     //         console.log('user, jwt, token', isAuthenticated);
    //     //         const token = await getAccessTokenSilently();
    //     //         console.log('user, jwt, token', isAuthenticated);
    //     //         localStorage.setItem('token', token);
    //     //         const jwt = jwtDecode(token)
    //     //         console.log('user, jwt, token', jwt, token);
    //     //     }
    //     // })();
    // }, [isAuthenticated, getAccessTokenSilently]);

    // const getToken = async () => {
    //     if (isAuthenticated) {
    //         const token = await getAccessTokenSilently();
    //         // localStorage.setItem('token', token);
    //     }
    // }

    useEffect(() => {
        if (isAuthenticated && user) {
            dispatch(LoginAction(user,false));
            // Encrypt
            var ciphertext = CryptoJS.AES.encrypt(JSON.stringify(user), CRYPTO_SECRATE_KEY).toString();
            localStorage.setItem('token', ciphertext);
        }
    }, [isAuthenticated,user, dispatch]);

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            color: 'white'
        }}>
            <Loader />
        </div>
    )
}

export default Redirect